import React from 'react'
import { Redirect } from 'react-router-dom'
import Location from 'components/Location'
import AuthenticatedProductServerRedirect from './AuthenticatedProductServerRedirect'

const AuthenticatedRedirect = ({ query }) =>
  query.get('redirect_uri') ? (
    <Location to={query.get('redirect_uri')} replace />
  ) : query.get('client_id') ? (
    <AuthenticatedProductServerRedirect clientId={query.get('client_id')} />
  ) : (
    <Redirect to="/" />
  )

export default AuthenticatedRedirect



// WEBPACK FOOTER //
// ./src/components/AuthenticatedRedirect/index.js